import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// Service worker
import * as serviceWorker from './serviceWorker';

// Render de la App
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// Registrar los Web Components de Ionic
void import('@ionic/pwa-elements/dist/cjs/loader.cjs.js')
  .then(({ defineCustomElements }) => defineCustomElements(window))
  .catch(() => undefined);

// Service worker (PWA opcional)
// Si querés que funcione offline => cambiar a serviceWorker.register()
serviceWorker.unregister();
